<app-modal-window title="Сбросить реферальный доход"
                  [actions]="true"
                  [disabledConfirm]="resetRefIncomeForm.invalid"
                  (confirm)="resetReferralIncome()"
                  (close)="close()">
  <div class='content'>
    <div *ngIf="data.element" class="element">
      <p><span class="field-name">Имя реферала:</span>
        <a [routerLink]="['../../user/find', data.element.id]" (click)="close()"> {{data.element.name}}</a></p>
      <p><span class="field-name">Код:</span> {{data.element.code}}</p>
    </div>
    <form class="reset-ref-income-form" [formGroup]="resetRefIncomeForm">

      <mat-form-field appearance="outline" class="picker">
        <mat-label>Период начала циклов</mat-label>
        <mat-date-range-input [rangePicker]="picker2">
          <input matStartDate formControlName="dateFrom" placeholder="Start date">
          <input matEndDate formControlName="dateTo" placeholder="End date">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-date-range-picker #picker2></mat-date-range-picker>
        <mat-hint>Фильтр применяется по дате депозита, открывшего цикл, а не по дате расчёта или месячного переноса.</mat-hint>

        <mat-error *ngIf="resetRefIncomeForm.controls.dateFrom.hasError('matStartDateInvalid')">Invalid start date
        </mat-error>
        <mat-error *ngIf="resetRefIncomeForm.controls.dateTo.hasError('matEndDateInvalid')">Invalid end date</mat-error>
      </mat-form-field>

      <mat-form-field appearance='outline' class="reason">
        <mat-label>Причина</mat-label>
        <input matInput type='text' placeholder='Причина' formControlName="comment">
      </mat-form-field>

    </form>
  </div>
</app-modal-window>
